module.exports = __webpack_public_path__ + "img/22.261f8564.png";